import { useState } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $profileFeatureStore, $profileStore } from '@lib/store';
import { cn, PaletteUtils } from '@shared/utils';
import { ChangePasswordModal } from '../widgets';
import { Button, Icon, Text } from '@shared/widgets';
import ShieldIcon from '@assets/icons/shield.svg';
import ChevronIcon from '@assets/icons/chevron.svg';

interface UserSecurityOptionsProps {
  className?: string;
}

export const UserSecurityOptions = (props: UserSecurityOptionsProps) => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);
  const profileStore = useUnit($profileStore.store);

  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [showChangePassword, setShowChangePassword] = useState<boolean>(false);

  const { t } = useTranslation('profile');

  if (!profileFeatureStore.data?.profileSettings.changeOwnPassword) return null;
  return (
    <div
      className={cn(
        'border-b-gray-200 mb-2 cursor-pointer border-b last:mb-0 last:border-b-0',
        PaletteUtils.isVcfcPalette && 'border-b-gray-black/40',
        props.className,
      )}
    >
      <div
        className={cn(
          'mb-2 flex min-h-12 cursor-pointer items-center px-0 py-4 transition-colors duration-200',
          'hover:bg-smoky-white dark:hover:bg-transport-black',
        )}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <div
          className={cn(
            'mr-4 flex flex-none items-center justify-center text-slate transition-colors duration-200 dark:text-white',
            PaletteUtils.isInsigniaPalette && [isOpen && 'text-primary dark:text-primary'],
          )}
        >
          <Icon icon={<ShieldIcon />} color='inherit' />
        </div>
        <Text className='flex-auto'>{t('securityOptions.title')}</Text>
        <div className={cn('flex items-center justify-center text-center transition-transform duration-200', isOpen && 'rotate-180')}>
          <Icon icon={<ChevronIcon />} className='-rotate-90' />
        </div>
      </div>
      <div className={cn(!isOpen ? 'hidden' : 'block pt-3')}>
        <Button className='mb-5' color='outlined' fullWidth onClick={() => setShowChangePassword(true)}>
          {t('buttons.changePassword', { ns: 'common' })}
        </Button>
        <ChangePasswordModal isOpen={showChangePassword} onClose={() => setShowChangePassword(false)} profileId={profileStore.data!.id} />
      </div>
    </div>
  );
};
